import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { AboutOwnerMini, PageListMini, PageSection } from '../index';

interface CampaignMini {
  totalCount: number;
  campaigns: {
    id: string;
    title: string;
    logo?: string | null;
    summary?: string | null;
    url: string;
  }[];
  charityRegistrationNumber?: string;
  charityShortName?: string;
  charityName?: string;
}

const CampaignMini: FunctionComponent<CampaignMini> = ({
  totalCount,
  campaigns,
  charityName,
  charityRegistrationNumber,
  charityShortName,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  if (totalCount === 1) {
    const [{ url, logo, title, summary }] = campaigns;
    return (
      <AboutOwnerMini
        ownerUrl={url}
        logo={logo}
        name={title}
        description={summary}
        registrationNumber={charityRegistrationNumber}
        parentOwnerUrl={charityShortName ? `/${charityShortName}` : undefined}
        parentOwnerName={charityName}
      />
    );
  }

  return (
    <PageSection
      title={t('page.campaignMiniTitle')}
      className="jg-pages-aboutownermini"
      count={totalCount}
    >
      <PageListMini pages={campaigns} totalCount={totalCount} />
    </PageSection>
  );
};

export default CampaignMini;
